import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DynamicGuardsService {
  private guards: any[] = [];

  setGuards(guards: any[]) {
    this.guards = guards;
  }

  getGuards() {
    return this.guards;
  }
}
